import { FC, ReactElement } from "react";
import { Table } from "react-bootstrap";
import { ImportRowError } from "../models/ProductCapabilitiesModels";

interface Props {
  errors: ImportRowError[];
}

export const ProductCapabilitiesImportErrorTable: FC<Props> = ({ errors }): ReactElement | null => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div data-testid="product-capabilities-error-table">
      <h5>Import errors ({errors.length})</h5>
      <Table size="sm" striped bordered>
        <thead>
          <tr>
            <th style={{ width: "80px" }}>Row</th>
            <th style={{ width: "200px" }}>Product code</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((e, idx) => (
            <tr key={`${e.row}-${idx}`}>
              <td>{e.row === 0 ? "—" : e.row}</td>
              <td>{e.productCode ?? "—"}</td>
              <td>{e.reason}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
